export default class CamelCaseConverter {

    static toCamelCase(str) {
        return str.replace(/-([a-z])/g, function (m, w) {
            return w.toUpperCase();
        });
    }
}
